import { ISkill, ISkillItem } from '../../../types'
import axios from '../../../helpers/axios'

export default {
  async create (context: ISkill, payload: {name: string, skill_id: number}): Promise<any> {
    const response = await axios().post(context.endpoints.skillItems, payload)
    return response.data
  },

  async update (context: ISkillItem, payload: {name: string, skill_id: number, skill_item_id: number}): Promise<any> {
    const response = await axios().patch(context.endpoints.update, {name: payload.name})
    return response.data
  },

  async destroy (context: ISkillItem): Promise<any> {
    const response = await axios().delete(context.endpoints.update)
    return response.data
  }
}
